import './view.scss';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.accordion-details').forEach(details => {
        const summary = details.querySelector(':scope > .accordion-summary');
        const content = details.querySelector(':scope > .accordion-content');
        if (!summary || !content) return;

        const sizeAnswer = () => {
            if (details.dataset.open === 'true') content.style.maxHeight = `${content.scrollHeight}px`;
        };
        const setOpen = open => {
            details.dataset.open = String(open);
            summary.setAttribute('aria-expanded', String(open));
            content.setAttribute('aria-hidden', String(!open));
            content.inert = !open;
            content.style.maxHeight = open ? `${content.scrollHeight}px` : '0px';
        };
        setOpen(details.dataset.open === 'true');
        summary.addEventListener('click', () => setOpen(details.dataset.open !== 'true'));
        // Images, nested blocks, and text reflow can change the answer's height.
        if (window.ResizeObserver && content.firstElementChild) {
            new ResizeObserver(sizeAnswer).observe(content.firstElementChild);
        }
        window.addEventListener('resize', sizeAnswer, { passive: true });
    });
});
